import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.css'
import '@/assets/fonts/fonts.css'
// 全局注册
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import {JSEncrypt} from '../public/js/lib/jsencrypt/jsencrypt.min/jsencrypt'
import '../public/js/common'
import '../public/js/lib/layui/layui'
import utils from '../public/js/urlGet'; //获取url参数
import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);
Vue.prototype.$utils = utils;
Vue.use(Antd)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.directive('anchor', {
  inserted : function(el, binding) {
    el.onclick = function() {
      $('html,body').animate({
        scrollTop:($('#' + binding.value).offset().top + 'px')
      }, 800);
    }
  }
})



// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el, binding) {
    // 聚焦元素
    var focus = binding.value;
    if (focus) {
      el.focus()
    }
  }
})

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', {
  inserted: async function (el, binding) {//指令名称为：real-img
    let imgURL = binding.value;//获取图片地址
    if (imgURL) {
      let exist = await imageIsExist(imgURL);
      if (exist) {
        el.setAttribute('src', imgURL);
      } else if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
})

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
  return new Promise((resolve) => {
    var img = new Image();
    img.onload = function () {
      if (this.complete == true){
        resolve(true);
        img = null;
      }
    }
    img.onerror = function () {
      resolve(false);
      img = null;
    }
    img.src = url;
  })
}

Vue.directive('highlight', function (el, binding) {
    let obj = binding.value || {};
    var keyword = obj.keyword;
    var value = obj.value;
    if (value && keyword) {
      el.innerHTML = value.replaceAll(keyword, '<k style="color:#FF5722">' + keyword + '</k>')
    } else {
      el.innerHTML = value || ''
    }
  }
)

Vue.filter('highlight', function (value, keyword, defaultString) {
  if (!value || !keyword) {
    return value || '';
  }
  return value.replaceAll(keyword, '<k style="color:#FF5722">' + keyword + '</k>');
});

Vue.filter('moment', function (value, formatString, defaultString) {
  var val = value;
  if (!isNaN(value)) {
    val = Number(val);
  }
  return formatDate(val, formatString, defaultString);
});

Vue.filter('preciseDiff', function (value) {
  let now = moment();
  let dataOne = now.format('YYYY-MM-DD HH:mm:ss');
  let dateTwo = now.add(value, 'minutes').format('YYYY-MM-DD HH:mm:ss');
  let replace = moment.preciseDiff(dataOne, dateTwo)
    .replace(/year(s)?|month(s)?|day(s)?|hour(s)?|minute(s)?|second(s)?/g,
      function(v) {
        if (/year(s)?/.test(v)) {
          return "年"
        }
        if (/month(s)?/.test(v)) {
          return "月"
        }
        if (/day(s)?/.test(v)) {
          return "天"
        }
        if (/hour(s)?/.test(v)) {
          return "小时"
        }
        if (/minute(s)?/.test(v)) {
          return "分钟"
        }
        if (/second(s)?/.test(v)) {
          return "秒"
        }
        return ""
      }
    ).replace(/\s+/g, "");
  return replace;
});

Vue.filter('pv', function (value, property, defaultString) {
  return value ? value[property] : '';
});

Vue.filter('thousand', function (num) {
  if (num == 0) {
    return num;
  }
  if (!num) {
    return "";
  }
  return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
      return $1 + ",";
    });
  });
});

function formatDate(value, formatString, defaultString){
  if(value == null){
    return defaultString ? defaultString : "";
  }
  formatString = formatString || 'YYYY-MM-DD HH:mm';
  return moment(value).tz('Asia/Shanghai').format(formatString);
}

Vue.filter('dictValue', function (dicts, dictValue) {
  if(dicts){
    for(var i = 0; i < dicts.length; i++){
      if(dicts[i].value == dictValue){
        return dicts[i].label;
      }
    }
  }
  return "";
});

// 定义全局点击函数
Vue.prototype.globalClick = function (callback) {
  document.getElementById('app').onclick = function (e) {
    callback(e);
  };
};

Array.prototype.indexOf = function (val, property) {
  for (var i = 0; i < this.length; i++) {
    if (!property && this[i] == val) {
      return i;
    } else if (property && this[i][property] == val) {
      return i;
    }
  }
  return -1;
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
